module.exports = __webpack_public_path__ + "media/video-paperclicks.2f3ddc3b.mp4";